import React, { useState, useRef, useEffect, useMemo, useCallback } from 'react'
import dayjs from 'dayjs'
import Resource from './Resource'
import Person from './Person'
import WeekdayComponent from './Weekday'
import { useGlobalState, getGlobalState } from '../../store'
import { setRemoteCall } from '../../remote'
import { toast } from 'react-toastify'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isBetween from 'dayjs/plugin/isBetween'
import isoWeek from 'dayjs/plugin/isoWeek'
import lz from 'lz-string'
import { Week } from './styled'
dayjs.extend(customParseFormat)
dayjs.extend(isBetween)
dayjs.extend(isoWeek)
const columnNames = ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab', 'Dom']

const Boards = (props) => {
  // const [viewOptions, setviewOptions] = useGlobalState('viewOptions')
  const [gettingRelations, setGettingRelations] = useState(false)
  const [viewOptions] = useGlobalState('viewOptions')
  const [lastFetchedDate, setLastFetchedDate] = useGlobalState(
    'lastFetchedDate'
  )
  const [pickerSource] = useGlobalState('pickerSource')
  const montRef = useRef()
  // const pickerSource = getGlobalState('pickerSource')

  // const [projects, setProjects] = useGlobalState('projects')
  const projects = getGlobalState('projects')
  const [updateRelations, setUpdateRelations] = useGlobalState(
    'updateRelations'
  )
  // const [resources, setResources] = useGlobalState('resources')
  const resources = getGlobalState('resources')
  const [relations, setRelations] = useGlobalState('relations')
  // const [resourceTypes, setResourceTypes] = useGlobalState('resourceTypes')
  const resourceTypes = getGlobalState('resourceTypes')
  // const [allUsers, setUsers] = useGlobalState('users')
  const allUsers = getGlobalState('users')
  // const [userTypes, setUserTypes] = useGlobalState('userTypes')
  const userTypes = getGlobalState('userTypes')

  useEffect(() => {
    if (updateRelations || lastFetchedDate !== viewOptions?.date) {
      setUpdateRelations(false) //lets stop the update loop
      setGettingRelations(true)
      setLastFetchedDate(viewOptions?.date) // Track the date we're fetching for
      setRemoteCall('getRelations', viewOptions?.date, '', (cb) => {
        if (!cb) {
          setGettingRelations(false)
          return
        }
        // const compressed = lz.compressToBase64(JSON.stringify(relations))
        // lets decompress the data
        const decompressed = lz.decompressFromBase64(cb)
        const relations = JSON.parse(decompressed)
        setGettingRelations(false)
        setRelations(relations)
      })
    }
    return () => {}
  }, [viewOptions?.date, updateRelations])

  // useEffect(() => {
  //   if (viewOptions && viewOptions.displayType === 'week') {
  //     if (projects && projects.length > 0) {
  //       let projectMaxHeight = {}
  //       setTimeout(() => {
  //         projects.map(p => {
  //           let domP = document.getElementsByClassName(p._id)
  //           Object.keys(domP)
  //             .map(d => {
  //               domP[d].style.minHeight = `auto`
  //               const rect = domP[d].getBoundingClientRect()
  //               projectMaxHeight[p._id] =
  //                 (projectMaxHeight[p._id] || 0) < rect.height
  //                   ? rect.height
  //                   : projectMaxHeight[p._id]
  //               return d
  //             })
  //             .map(d => {
  //               domP[d].style.minHeight = `${projectMaxHeight[p._id] + 25}px`
  //             })
  //         })
  //       }, 2000)
  //     }
  //   } else {
  //     setTimeout(() => {
  //       projects.map(p => {
  //         let domP = document.getElementsByClassName(p._id)
  //         Object.keys(domP).map(d => {
  //           domP[d].style.minHeight = `auto`
  //         })
  //       })
  //     }, 0)
  //   }
  // }, [viewOptions, updateRelations, projects])

  // lets filter users by state
  const users = useMemo(() => allUsers.filter((u) => u.status < 2), [allUsers])

  /**
   * Setup initial data
   */
  const currentDate = viewOptions.date //need to update this with controllers
  let searchDate = dayjs(currentDate)
  let items = 1
  if (viewOptions.displayType === 'week') {
    items = 5
    searchDate = dayjs(currentDate).startOf('isoWeek')
  }

  /**
   * Create lookup maps for O(1) access instead of O(n) .find() operations
   */
  const { usersMap, resourcesMap, userTypesMap, resourceTypesMap } = useMemo(() => {
    const usersMap = new Map(users.map(u => [u._id, u]))
    const resourcesMap = new Map(resources.map(r => [r._id, r]))
    const userTypesMap = new Map(userTypes.map(t => [t._id, t]))
    const resourceTypesMap = new Map(resourceTypes.map(t => [t._id, t]))
    return { usersMap, resourcesMap, userTypesMap, resourceTypesMap }
  }, [users, resources, userTypes, resourceTypes])

  /**
   * 1 .Generate projects and relations hierarchy
   */
  const generateScene = useMemo(() => {
    return [...Array(items).keys()].map((i) => {
      let currDate = searchDate
      if (viewOptions.displayType === 'week') {
        currDate = dayjs(searchDate).add(i, 'days')
      }
      return {
        id: currDate.format('DD/MM/YYYY'),
        type: 'container',
        name: columnNames[currDate.isoWeekday() - 1],
        date: currDate.format('DD/MM/YYYY'),
        children: [],
        // children: getSceneProjectsPayload(currDate)
      }
    })
  }, [searchDate, items, viewOptions.displayType])

  /**
   * 2. Get nestable projects for each day of the scene
   */
  const getSceneProjectsPayload = useCallback(
    (today) => {
      const todayDayjs = dayjs(today, 'DD/MM/YYYY')
      return (
        projects
          .filter((proj) => {
            return todayDayjs.isBetween(
              dayjs(proj.startDate),
              dayjs(proj.endDate),
              'day',
              '[]'
            )
          })
          .sort((a, b) => b.priority - a.priority)
          .map((project) => {
            return {
              id: project._id,
              type: 'container',
              t: project.type,
              name: project.name,
              code: project.code,
              children: getSceneChildResourcesPayload(project._id, null, today, todayDayjs),
            }
          }) || []
      )
    },
    [projects, relations, usersMap, resourcesMap]
  )

  /**
   * 3. Get nestable resouces for project scene
   * on the weekend users will only work on special projects
   * so when save the weenkend will only add one day
   * @param {} projectId
   */
  const getSceneChildResourcesPayload = useCallback(
    (projectId, accountId, today, dateObject = null) => {
      const dateObj = dateObject || dayjs(today, 'DD/MM/YYYY')
      const weekDay = dateObj.isoWeekday()
      const isWeekend = weekDay === 6 || weekDay === 7
      
      //lets check if resource is available during this dates
      return relations
        .filter((rel) => {
          if (!rel.projectId || !rel.projectId.includes(projectId)) {
            return false
          }
          
          const available = checkPersonAvailability(projectId, today, rel, dateObj)
          if (!available) return false
          
          // lets evaluate if its within dates
          if (accountId && rel.accountId && rel.accountId.includes(accountId)) {
            if (isWeekend) {
              return dayjs(rel.startDate).diff(dateObj, 'days') === 0
            } else {
              // we need to check if we are returning resources and not users!!
              return (
                rel.resourceId &&
                rel.resourceId.length > 0 &&
                dateObj.isBetween(
                  dayjs(rel.startDate),
                  dayjs(rel.endDate),
                  'day',
                  '[]'
                )
              )
            }
          } else {
            if (isWeekend) {
              return (
                dayjs(rel.startDate).isSame(dateObj, 'day') &&
                dayjs(rel.endDate).isSame(dateObj, 'day')
              )
            } else {
              return dateObj.isBetween(
                dayjs(rel.startDate),
                dayjs(rel.endDate),
                'day',
                '[]'
              )
            }
          }
        })
        .map((res) => {
          //now er are getting the correct resource card
          let cardPayload = {
            relationId: res._id,
          }
          if (res?.resourceId?.length > 0) {
            const resourceId = res.resourceId[0]
            cardPayload = resourcesMap.get(resourceId) || {}
            cardPayload.cardType = 'resources'
            cardPayload.author = res.author
            cardPayload.accountId =
              res.accountId && res.accountId.length > 0
                ? res.accountId[0]
                : null
          } else if (res?.accountId && res?.accountId?.length > 0) {
            const accountId = res.accountId[0]
            cardPayload = usersMap.get(accountId) || {}
            cardPayload.author = res.author
            cardPayload.userId = accountId
            cardPayload.cardType = 'users'
          }
          return {
            ...cardPayload,
            relationId: res._id,
            startDate: res.startDate,
            endDate: res.endDate,
            relStatus: res.status,
          }
        })
        .sort((a, b) => (b.sort || 0) - (a.sort || 0))
    },
    [relations, usersMap, resourcesMap]
  )

  const checkPersonAvailability = (projectId, date, payload, dateObj = null) => {
    let currUser = payload
    //lets only the correct usercard
    if (!payload.availability && !payload.accountId) {
      return true
    }
    // if its a relational card then lets find the correct user card
    if (payload.accountId && payload.accountId.length > 0) {
      currUser = usersMap.get(payload.accountId[0])
    }
    //user is not available
    if (!currUser) return false
    // user has no availability
    if (!currUser.availability || currUser.availability.length < 1) return true

    const dateToCheck = dateObj || dayjs(date, 'DD/MM/YYYY')
    
    //lets check if any of the availability days are matching today
    return (
      currUser &&
      currUser.availability &&
      currUser.availability instanceof Array &&
      !currUser.availability.find((dates) => {
        const dateStart = dayjs(dates[0], ['YYYY-MM-DDTHH:mm', 'YYYY-MM-DD'])
        const dateEnd = dayjs(dates[1], ['YYYY-MM-DDTHH:mm', 'YYYY-MM-DD'])
        return dateToCheck.isBetween(
          dateStart,
          dateEnd,
          'day',
          '[]'
        )
      })
    )
  }

  /**
   * Lets check before dropping card if card can be dropped
   * @param {*} columnId
   * @param {*} cardId
   * @param {*} payload
   */
  const cardCanBeDropped = useCallback((columnId, cardId, payload) => {
    if (payload.source !== 'picker') return true
    
    //lets get the projects and return if no project is found
    const projectsPayload = getSceneProjectsPayload(columnId)
    for (const project of projectsPayload) {
      if (project.children.some(resource => resource._id === payload._id)) {
        return false
      }
    }
    return true
  }, [getSceneProjectsPayload])

  /**
   * When we drop a card we need to set it to the project
   * otherwise if its back to resources we need to remove it from the project
   *
   * @param {*} columnId
   * @param {*} cardId
   * @param {*} dropResult
   */
  const onResourceCardDrop = (columnId, cardId, accountId, dropResult) => {
    const { removedIndex, addedIndex, payload } = dropResult
    if (addedIndex !== null) {
      //lets look for duplicates
      if (!cardCanBeDropped(columnId, cardId, payload)) {
        toast.error('Recurso já atribuido neste dia')
        // TODO: NEED TO CHECK IF MULTIRESOURCE
        // return null
      }
      //it its a person we need to check if its available
      if (!checkPersonAvailability(cardId, columnId, payload)) {
        toast.error('Recurso não está disponível para esta data')
        return null
      }
      //lets send the request to the backend
      const thisProjects = projects.find((prj) => prj._id === cardId)
      setRemoteCall(
        'setRelationToProject',
        {
          dateStart: columnId,
          dateEnd:
            thisProjects && dayjs(thisProjects.endDate).format('DD/MM/YYYY'),
          projectId: cardId,
          accountId: accountId,
          resource: payload,
          sort: addedIndex,
        },
        null
      )
    } else if (removedIndex !== null) {
      props.setFromColumn(columnId)
    }
  }

  /**
   * used to prepare data for displat
   * sort, and groups board data
   * @param {*} projectResources
   */
  const getSortedGroups = (projectResources) => {
    // lets create the groups
    let usedProjectGroups = []
    let sortedProjectResources = []
    const projectResourcesGroup = projectResources.reduce(
      (accumulator, currentValue) => {
        let thisId
        if (currentValue.role && userTypes) {
          const userGroup = userTypes.find((t) => currentValue.role === t._id)
          if (userGroup) {
            thisId = userGroup._id
            usedProjectGroups[thisId] = { ...userGroup, type: 'user' }
          }
        } else if (currentValue.type && resourceTypes) {
          const resourceGroup = resourceTypes.find(
            (t) => currentValue.type === t._id
          )
          if (resourceGroup) {
            thisId = resourceGroup._id
            usedProjectGroups[thisId] = { ...resourceGroup, type: 'resource' }
          }
        }
        if (!accumulator[thisId]) accumulator[thisId] = []
        accumulator[thisId].push(currentValue)
        return accumulator
      },
      {}
    )

    const sortedGroups = Object.keys(projectResourcesGroup)
      .sort((a, b) => {
        if (usedProjectGroups[a] && usedProjectGroups[b]) {
          if (
            usedProjectGroups[a].type !== 'resource' &&
            usedProjectGroups[b].type === 'resource'
          ) {
            return -1
          } else if (
            usedProjectGroups[a].type === 'resource' &&
            usedProjectGroups[b].type !== 'resource'
          ) {
            return 1
          } else {
            return (
              (usedProjectGroups[b].priority || 0) -
              (usedProjectGroups[a].priority || 0)
            )
          }
        }
        return b - a
      })
      .map((group) => {
        sortedProjectResources = [
          ...sortedProjectResources,
          ...[group],
          ...projectResourcesGroup[group],
        ]
        return group
      })

    return {
      usedProjectGroups,
      projectResourcesGroup,
      sortedGroups,
      sortedProjectResources,
    }
  }

  /**
   * Render output
   */
  return (
    <Week pickerSource={pickerSource ? 'true' : 'false'} ref={montRef}>
      {generateScene.map((column, i) => {
        return (
          <WeekdayComponent
            i={i}
            column={column}
            users={users}
            dayResources={props.dayResources}
            setDayResources={props.setDayResources}
            viewOptions={viewOptions}
            pickerSource={pickerSource}
            // getSceneProjectsPayload={getSceneProjectsPayload}
            projectsPayloadMap={getSceneProjectsPayload(column.id)}
            getSceneChildResourcesPayload={getSceneChildResourcesPayload}
            getSortedGroups={getSortedGroups}
            onClick={props.onClick}
            onResourceCardDrop={onResourceCardDrop}
            collapsedProjects={props.collapsedProjects}
          />
        )
      })}
    </Week>
  )
}

export default Boards
